import { getSRconfigs, orders } from '@/api/endpoints'

const fetchSrConfigsByLevel = (levelId) => {
  return new Promise((resolve) => {
    getSRconfigs.getSRconfigsByLevel({ levelId })
      .then(response => {
        if (response.data.success) {
          resolve({
            success: true,
            data: response.data.response
          })
        } else {
          console.log('error')
          resolve({
            success: false
          })
        }
      })
      .catch(() => {
        resolve({
          success: false,
          apiError: true
        })
      })
  })
}

const fetchSuccessRates = (consultantId, filters) => {
  return new Promise((resolve) => {
    const params = {
      ...filters
    }
    orders.getSuccessRates({ consultantId }, { params })
      .then(response => {
        if (response.data.success) {
          let data = response.data.response
          let items = []

          data.forEach(item => {
            items.push({
              from_date: item.from_date,
              to_date: item.to_date,
              success_rate: item.success_rate,
              orders_completed: item.orders_completed,
              orders_failed: item.orders_failed,
              jforce_level: item.jforce_level,
              impact_perc: item.impact_perc,
              hide_impact: item.hide_impact
            })
          })

          resolve({
            success: true,
            data: items
          })
        }
      })
      .catch(() => {
        resolve({
          success: false
        })
      })
  })
}
export default {
  fetchSrConfigsByLevel,
  fetchSuccessRates
}
